import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Tooltip, Col, Row } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import styles from './styles.module.css'; // Ensure styles are imported
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { toast, ToastContainer } from 'react-toastify';
import { Container } from 'react-bootstrap';
import AddCouponForm from './AddCouponForm';
import EditCouponForm from './EditCouponForm';
import { FaCopy } from 'react-icons/fa';
import moment from 'moment';
import CouponDetails from './CouponDetails';
import { connect } from 'react-redux';


const Coupon = ({type,userGroups}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isRequesting, setIsRequesting] = useState(false);
    const [couponCodes, setCouponCodes] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
    });

    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [deleteCoupon, setDeleteCoupon] = useState(null);
    const [addCoupon, setAddCoupon] = useState(false);
    const [editCoupon, setEditCoupon] = useState(false);
    const [viewCoupon, setViewCoupon] = useState(false);
    const [authorizedPermissions, setAuthorizedPermissions] = useState({});


    useEffect(() => {
        getCouponCodes();
        handleAdminAuthorizedPermissions()
    }, []);

    
    
    const handleAdminAuthorizedPermissions =  () => {
        try {
            if(type === 'Breathe-Admin'){

                const allAuthorizedPermissions = {};
                userGroups.forEach((userGroup)=> Object.assign(allAuthorizedPermissions,JSON.parse(userGroup.permissions)));
                setAuthorizedPermissions(allAuthorizedPermissions)
                // console.log('Breathe Admin user ',userGroups);
                // const resultantUserGroup = userGroups.find((userGroup)=>userGroup.groupName.includes('CouponCodesAccessGroup'))
                // setAuthorizedPermissions(JSON.parse(resultantUserGroup.permissions))
                // setAuthorizedPermissions({addCouponCode:'false',editCouponCode:'false',deleteCouponCode:'false'})

                // console.log('userGroup permissions : ', JSON.parse(resultantUserGroup.permissions))
               
                
        
            }
           
        } catch (error) {
            console.error('Error in handling Admin resources authorization',error);
            
        } 
    };

    const getCouponCodes = async (page = 1, pageSize = 10) => {
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getCouponCodeList({ page, limit: pageSize });
            setCouponCodes(res.data.coupons);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
            setIsRequesting(false);
        } catch (error) {
            console.error(error);
            toast.error('Error fetching coupon codes.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (record) => {
        setSelectedCoupon(record);
        setEditCoupon(true);
    };

    const handleDeleteConfirmation = (record) => {
        setDeleteCoupon(record);
    };

    const handleDelete = async () => {
        try {
            setIsRequesting(true);
            await BreathAPIs.deleteCouponCode(deleteCoupon?._id);
            toast.success('Coupon deleted successfully.');
            getCouponCodes(pagination.current, pagination.pageSize);
            setIsRequesting(false);
        } catch (error) {
            console.error(error);
            toast.error('Error deleting coupon.');
        } finally {
            setDeleteCoupon(null);
        }
    };

    const handleTableChange = (pagination) => {
        const { current, pageSize } = pagination;
        getCouponCodes(current, pageSize);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        toast.success('Copied to clipboard!');
    };

    const formatDate = (dateString) => {
        return dateString ? moment(dateString).format('DD/MM/YYYY HH:mm') : 'N/A';
    };

    const columnCouponCodes = [
        {
            title: 'ID',
            dataIndex: '_id',
            key: 'id',
            width: 120,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >
                    <Tooltip title={text}>
                        <span className={styles['support-view']} onClick={
                            () => {
                                setSelectedCoupon(record);
                                setViewCoupon(true)
                            }
                        }>
                            {text.length > 5 ? text.substring(0, 5) + '...' : text}
                        </span>
                    </Tooltip>
                    <Tooltip title="Copy">
                        <Button shape="circle" icon={<FaCopy />} onClick={() => copyToClipboard(text)} />
                    </Tooltip>
                </div>
            ),
        },
        {
            title: 'Coupon Name',
            dataIndex: 'couponName',
            key: 'couponName',
            width: 200,
        },
        {
            title: 'Benefit',
            dataIndex: 'benefit',
            key: 'benefit',
            width: 100,
            render: (text) => <span>${text}</span>,
        },
        {
            title: 'Coupon Code',
            dataIndex: 'couponCode',
            key: 'couponCode',
            width: 200,
            render: (text) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span>{text}</span>
                    <Tooltip title="Copy">
                        <Button shape="circle" icon={<FaCopy />} onClick={() => copyToClipboard(text)} />
                    </Tooltip>
                </div>
            ),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            width: 150,
            render: (text) => text === 'account-creation' ? 'Account Creation' : 'Promotion',
        },
        {
            title: 'Usage Limit',
            dataIndex: 'numberOfUsage',
            key: 'numberOfUsage',
            width: 150,
            render: (text) => text !== null ? text : 'Unlimited',
        },
        {
            title: 'Times Used',
            dataIndex: 'timesUsed',
            key: 'timesUsed',
            width: 150,
            render: (text) => text !== null ? text : '0',
        },
        {
            title: 'Expiry Date',
            dataIndex: 'expiry',
            key: 'expiry',
            width: 180,
            render: (text) => formatDate(text),
        },
        {
            title: 'Locations',
            dataIndex: 'locations',
            key: 'locations',
            width: 200,
            render: (text, record) => {
                return record?.locations && record.locations.length > 0
                    ? record.locations.map((loc) => loc.locationName).join(', ')
                    : 'N/A';
            },
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 180,
            render: (text) => formatDate(text),
        },
        {
            title: 'Enabled',
            dataIndex: 'enabled',
            key: 'enabled',
            width: 75,
            render: (text) => (text ? 'Yes' : 'No'),
        }
        
      
        
       
    ];

    const columnCouponCodesActionObject =  {
        title: 'Actions',
        key: 'actions',
        width: 100,
        fixed: 'right',
        render: (text, record) => (
            <div style={{ display: 'flex', gap: '10px' }}>
                    {
                        <Tooltip title="Edit">
                         <Button shape="circle" icon={<AiFillEdit />} onClick={() => handleEdit(record)} />
                        </Tooltip>
                        
                    }
                {
                    (type==='Admin') ? 
                    <Tooltip title="Delete">
                    <Button shape="circle" danger icon={<AiFillDelete />} onClick={() => handleDeleteConfirmation(record)} />
                </Tooltip>
                :
               null

                }
            </div>
        ),
    }

    // (((JSON.parse(authorizedPermissions?.upsertCouponCode || 'false') )

    //         && (type === 'Breathe-Admin')) || (type === 'Admin')) ?
    //         (
    //             columnCouponCodes.push(columnCouponCodesActionObject)
    //         )
    //         :
    //         null

            



    return (
        <Container>
            <ToastContainer />
            <Row justify="end" gutter={[16, 16]} style={{ marginBottom: '15px' }}>
                {
                      (JSON.parse(authorizedPermissions?.upsertCouponCode || 'false') && (type === 'Breathe-Admin')) || (type==='Admin') ?
                <Col>
                    <Button type="primary" onClick={() => setAddCoupon(true)}>Add New Coupon</Button>
                </Col>
                :
                null

                }
            </Row>
            <Table
                loading={isLoading}
                dataSource={couponCodes}
                columns={(((JSON.parse(authorizedPermissions?.upsertCouponCode || 'false'))

                    && (type === 'Breathe-Admin')) || (type === 'Admin')) ?
                    (
                        columnCouponCodes.concat(columnCouponCodesActionObject)
                    )
                    : columnCouponCodes}
                rowKey="_id"
                pagination={pagination}
                onChange={handleTableChange}
                className={styles['data-list']}
                bordered
                size="middle"
                scroll={{ x: 'calc(600px + 50%)' }}
                rowClassName={(record) =>
                    record.expiry && moment(record.expiry).isBefore(moment()) ? styles['grayish-row'] : ''
                }
            />
            <AddCouponForm
                modalVisible={addCoupon}
                closeModal={() => setAddCoupon(false)}
                refreshCoupons={() => getCouponCodes(pagination.current, pagination.pageSize)}
            />
            <EditCouponForm
                modalVisible={editCoupon}
                closeModal={() => setEditCoupon(false)}
                refreshCoupons={() => getCouponCodes(pagination.current, pagination.pageSize)}
                selectedCoupon={selectedCoupon}
            />
            <CouponDetails
                modalVisible={viewCoupon}
                closeModal={() => setViewCoupon(false)}
                selectedCoupon={selectedCoupon}
            />
            <Modal
                title="Confirm Deletion"
                open={!!deleteCoupon}
                onOk={handleDelete}
                onCancel={() => setDeleteCoupon(null)}
                okText="Yes, Delete"
                cancelText="Cancel"
                cancelButtonProps={{ disabled: isRequesting }}
                confirmLoading={isRequesting}
            >
                <p>Are you sure you want to delete this coupon?</p>
            </Modal>
        </Container>
    );
};

// Coupon.propTypes = {
//     type: propTypes.string
// }

const mapStateToProps = (state) =>({
    type: state.auth && state.auth.user ? state.auth.user.type : null,
    
    userGroups : state.auth && state.auth.user ? state.auth.user.userGroups : null
})

export default connect(mapStateToProps)(Coupon);
